var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3346 15.9998C29.3346 23.3598 23.3613 29.3332 16.0013 29.3332C8.6413 29.3332 4.14797 21.9198 4.14797 21.9198M4.14797 21.9198H10.1746M4.14797 21.9198V28.5865M2.66797 15.9998C2.66797 8.63984 8.58797 2.6665 16.0013 2.6665C24.8946 2.6665 29.3346 10.0798 29.3346 10.0798M29.3346 10.0798V3.41317M29.3346 10.0798H23.4146",
    stroke: "#094C3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshGreen);
export default __webpack_public_path__ + "static/media/refresh-green.d0d6f0c4891f8b436cb42b29fbbf6b35.svg";
export { ForwardRef as ReactComponent };